import React, {Component} from 'react';
import wrapper from "../../hoc/wrapper";
import TagRef from '../../components/Static/TagRef';
import Header from "../../components/Header/Header";
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap"

class CloudFormation extends Component {
    state = {
        links: [],
        showTagRef: false,
        fromAws: this.props.location.state.fromAws || false
    };

    componentWillMount() {
        const links = this.props.location.state.links;
        // const links = [{a : "a"}]
        this.setState({links: Object.keys(links).map(k => links[k])})
    }

    openInNewTab =(e, url) => {
        e.preventDefault();

        let win = window.open(url, '_blank');
        win.focus();
    };

    toggle = () =>{
        this.setState({
            showTagRef: !this.state.showTagRef
        });
    };


    render() {
        return (
            <div>
                <Header currentWizard="8" fromAws={this.state.fromAws}/>
                <main role="main">
                    <section className="section cloud-formation-section no-brdr">
                        <div className="container">
                            <div className="row black">
                                <div className="col-md-9 col-center text-center">
                                    <h1><strong>CloudFormation Install</strong></h1>
                                    <p>We have generated a custom CloudFormation script for you to install Xosphere
                                        Instance Orchestrator into your AWS account. Simply click on the Launch Stack
                                        button below to ger started.</p>
                                    {this.state.links.map((k, idx) => {
                                        return <a href={null} className="btn btn-lg btn-warning" key={idx}
                                                  onClick={(e) => this.openInNewTab(e, k)}>Launch Stack <i className="fa fa-chevron-circle-right"></i></a>
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="separator white text-center"><i className="fa fa-chevron-down black"></i></div>
                        <div className="container">
                            <div className="row black mt-5">
                                <div className="col-md-9 col-center text-center">
                                    <h1><strong>Enable Xosphere</strong></h1>
                                    <p className="mb-5">After the CloudFormation script has completed the installation,
                                        you can enable Xosphere on an individual Auto Scaling Group by adding a tag with
                                        the name and value below. You can also add additional configuration settings via
                                        tags if desired. Please refer to our <a href="#" onClick={e => {e.preventDefault(); this.setState({showTagRef: true})}}
                                                                                className="black underline">tag
                                            reference</a> for more details.</p>
                                    <div className="row">
                                        <div className="col-md-9 col-center">
                                            <div className="brdr-overlay">
                                                <table cellPadding="0" cellSpacing="0" align="center"
                                                       className="text-left">
                                                    <tbody>
                                                    <tr>
                                                        <td width="90" valign="top">Tag Name:</td>
                                                        <td valign="top"><span className="blue">xosphere.io/instance-orchestrator/<span
                                                            className="text-warning">enabled</span></span></td>
                                                    </tr>
                                                    <tr>
                                                        <td valign="top">Tag Value:</td>
                                                        <td valign="top"><span className="blue">true</span></td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <Modal isOpen={this.state.showTagRef} onHide={e => {this.setState({showTagRef: false})}} toggle={this.toggle} size="lg">
                        <ModalHeader toggle={this.toggle}>Tag References</ModalHeader>
                        <ModalBody>
                            <TagRef/>
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={e => {this.setState({showTagRef: false})}}>Close</Button>
                        </ModalFooter>
                    </Modal>
                </main>
            </div>
        )
    }
}

export default wrapper(CloudFormation);